import { createRequest } from '@savgroup-front-common/core/services/request';

export const CLAIM_CANCELLED = 'CLAIM_CANCELLED';

export const LOAD_CLAIM_SUMMARY = createRequest('LOAD_CLAIM_SUMMARY');
export const GET_CLAIM = createRequest('GET_CLAIM');
